

// client/src/api/auth/me.ts
import apiClient from "../client";
import { AxiosError } from "axios";
export interface MeResponse {
  success: boolean;
  data: {
    user: {
      _id: string;
      username: string;
      email: string;
      role: string;
      isVerified: boolean;
      twoFactorEnabled: boolean;
      // firstName/lastName (and related) may come back at the top level depending
      // on the endpoint, as well as under `profile`.
      name?: string;
      firstName?: string;
      lastName?: string;
      phone?: string;
      avatar?: string;
      profile?: {
        firstName?: string;
        lastName?: string;
        phone?: string;
        avatar?: string;
      };
      referralCode?: string;
      lastLogin?: string;
      createdAt: string;
      updatedAt: string;
    };
  };
}

export const getMe = async (): Promise<MeResponse> => {
  try {
    const response = await apiClient.get<MeResponse>('/auth/me');

    // Identity ADR: do NOT persist the role/user to localStorage as a source of
    // truth. The authoritative session is held in memory by AppContext (from this
    // call); route guards read role from there, not from an editable localStorage
    // blob.
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw error.response?.data || { success: false, message: 'Failed to fetch user data' };
    }
    throw { success: false, message: 'Failed to fetch user data' };
  }
};

